import React, { useCallback, useContext, useEffect, useState } from "react";
import { Dropdown, NavLink, OverlayTrigger, Tooltip } from "react-bootstrap";

// Components
import ModalAssign from "../modals/ModalAssign";
import ChatSidebar from "./ChatSidebar";

// Context
import { ChatContext } from "../../context/chat/ChatContext";
import { SocketContext } from "../../context/SocketContext";
import { AuthContext } from "../../context/AuthContext";

// Utils
import debounce from "../../utils/debounce";
import { fetchWithCX, fetchWithToken } from "../../api/fetch";
import { types } from "../../types/types";
import ModalClients from "../modals/ModalClients";
const baseURL = process.env.REACT_APP_API;
const baseUrlcx = process.env.REACT_APP_CX;

/**
 * Componente que renderiza el header del chat
 *
 * @param {object} props - Propiedades del componente
 * @param {function} props.setIsSearching - Función para establecer si se está buscando
 * @returns {JSX.Element} Componente de React
 */
const ChatHeader = ({ setIsSearching }) => {
  const [showModal, setShowModal] = useState(false); // Muestra el modal de asignación
  const [showSearch, setShowSearch] = useState(false); // Muestra el input de búsqueda
  const [showSidebar, setShowSidebar] = useState(false); // Muestra el sidebar
  const [show, setShow] = useState(false);
  const [Nota, setNota] = useState(null);
  // Contextos
  const { auth } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);
  const { chatState, dispatch } = useContext(ChatContext);
  const { activeChat } = chatState;

  const [cx, setcx] = useState(null);
  useEffect(() => {
    getInfoCx();
    getNota();
  }, [activeChat]);
  
  const getInfoCx = async () => {
    const { idcus } = activeChat;
    if (idcus != null) {
      const resp = await fetchWithCX(`chat/info/${idcus}`);
      if (resp.ok) setcx(resp.data);
    } else {
      setcx(null);
    }
  };
  const getNota = async () => {
    const resp = await fetchWithToken(
      `respuestas/notas`,
      {
        id_user: activeChat.id_user || activeChat.id,
      },
      "POST"
    );
    resp.ok && setNota(resp.data?.length > 0 ? resp.data[0].nota : null);
  };
  
  /**
   * Función para establecer el estado del chat
   * - Espera
   * - Cerrado
  *
  * @param {string} type - Tipo de asignación
  * @returns {void} No retorna nada
  */
 const handleAssign = (type) => {
   socket.emit("asignar", {
     agente: "",
     type,
     auth: auth.uid,
     id: activeChat.id,
    });
  };
  
  /**
   * Función para buscar mensajes en el chat
   * Utiliza un debounce para evitar múltiples peticiones
  *
  * @param {string} word - Palabra a buscar
  * @returns {void} No retorna nada
  */
 const searchChat = useCallback(
   debounce(async (word) => {
     if (!word && word.lenght <= 0) {
       setIsSearching(false);
       return;
      }
      
      // Petición al servidor
      const resp = await fetchWithToken(
        "sms/searchMessages",
        { id: activeChat.id, word },
        "POST"
      );
      
      // Se establece que se está realizando una búsqueda
      setIsSearching(true);
      
      if (resp.ok) {
        // Se cargan los mensajes en el estado
        dispatch({
          type: types.loadMessages,
          payload: resp.data,
        });
      }
    }, 600),
    [activeChat]
  );
  
  // Si está activo el sidebar, cerrarlo al cambiar de chat
  useEffect(() => {
    setShowSidebar(false);
  }, [activeChat]);
  const getBadgeColor = (estado) => {
    switch (estado) {
      case "RETIRADO":
        return "warning";
        case "ACTIVO":
          return "success";
          case 1:
            return "success";
            case "SUSPENDIDO":
              return "danger";
              case 0:
                return "danger";
                default:
                  return "secondary";
                }
              };
              
              // Función para determinar el ícono según el estado
              const getEstadoIcon = (estado) => {
                switch (estado) {
                  case "RETIRADO":
                    return "mdi-account-remove";
                    case "ACTIVO":
                      return "mdi-account-check";
                      case "SUSPENDIDO":
                        return "mdi-account-cancel";
                        case 0:
                          return "mdi-network-off";
                          case 1:
                            return "mdi-wifi-arrow-up-down";
                            default:
                              return "mdi-alert-circle-outline";
                            }
                          };
                          return (
                            <div
                            className="d-flex justify-content-between align-items-center border-bottom bg-light px-3 py-2 sticky-top"
                            style={{ zIndex: 100 }}
    >
      {/* Foto de perfil y nombre del usuario */}
      <div className="d-flex align-items-center">
        {/* Botón para regresar, solo móvil */}
        <i
          className="uil uil-arrow-left text-secondary fs-1 d-lg-none me-2"
          title="Regresar"
          onClick={() => {
            dispatch({
              type: types.closeChat,
            });
          }}
          />

        <img
          src={
            activeChat?.red.includes("http")
              ? `${activeChat.foto}`
              : `${baseURL}/${activeChat.foto}`
            }
            className="me-2 rounded-circle"
            height="38"
            alt="Foto de perfil"
            />

        <h5 className="text-secondary">
          {`${activeChat.first_name ?? ""} ${activeChat.last_name ?? ""}`}
        </h5>
      </div>
      {cx && (
        <a
          href={`${baseUrlcx}/admin/viewuser/${btoa(`${cx.id}`)}`}
          target="_blank"
          className="pointer"
        >
          <strong className="text-info">
            <b title={`Servicio:${cx.tipo} `}>
              {" "}
              ({cx.id}) {cx.nombre}
            </b>
            {cx.estado && (
              <span
                className={`badge bg-${getBadgeColor(cx.estado)} mx-1`}
                title={cx.estado}
              >
                <i className={`mdi ${getEstadoIcon(cx.estado)} `}></i>
              </span>
            )}
            {cx.tipo === "INALAMBRICO" && (
              <span
                className={`badge bg-${getBadgeColor(cx.estadoemi)} mx-1`}
                title={cx.estadoemi === 1 ? "EMISOR ONLINE" : "EMISOR OFFLINE"}
              >
                <i className={`mdi ${getEstadoIcon(cx.estadoemi)} `}></i>
              </span>
            )}
          </strong>
        </a>
      )}
      {Nota && (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>{Nota}</Tooltip>}>
          <small className="text-warning">
            <i className="mdi mdi-note-check" />{" "}
            {Nota.length > 20 ? Nota.substring(0, 20) + "..." : Nota}
          </small>
        </OverlayTrigger>
      )}

      <div className="d-flex justify-content-evenly align-items-center gap-3">
        {/* Barra y botón de búsqueda */}
        <div
          className={`search-container ${showSearch ? "open" : ""}`}
          onClick={() => setShowSearch(true)}
        >
          {showSearch && (
            <input
              type="text"
              className="search-input form-control"
              placeholder="Buscar..."
              onBlur={() => setShowSearch(false)}
              onKeyUp={(e) => searchChat(e.target.value)}
              autoFocus
            />
          )}

          <i
            className={`cursor-pointer uil uil-search text-secondary ${
              showSearch ? "d-none" : ""
            } font-20`}
            title="Buscar"
          />
        </div>
        <i
          className="mdi mdi-account-box-multiple text-secondary font-20"
          title="LIGAR CLIENTE"
          onClick={() => {
            setShow(true);
          }}
        />
        {/* Dropdown para cambiar el estado del chat */}
        <Dropdown
          className="conversation-actions d-inline-block"
          title="Estado del chat"
        >
          <Dropdown.Toggle
            variant="link"
            className="btn btn-sm btn-link arrow-none shadow-none p-0"
          >
            <i className="mdi mdi-format-list-checks text-secondary font-20" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleAssign("espera")}>
              <i className="uil uil-clock-three text-warning font-18 me-2" />
              <span className="text-warning">Espera</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleAssign("cerrado")}>
              <i className="uil uil-lock text-danger font-18 me-2" />
              <span className="text-danger">Cerrado</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setShowModal(true);
              }}
            >
              <i className="uil uil-user-check text-success font-18 me-2" />
              <span className="text-success">Asignar</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* Botón para mostrar el sidebar */}
        <i
          className="cursor-pointer uil uil-info-circle text-secondary font-20"
          title="Información"
          onClick={() => {
            setShowSidebar(!showSidebar);
          }}
        />
      </div>

      {/* Sidebar */}
      {showSidebar && (
        <ChatSidebar
          closeSidebar={() => {
            setShowSidebar(false);
          }}
          style={{
            transition: "all 0.3s ease",
          }}
        />
      )}

      {showModal ? (
        <ModalAssign
          show={showModal}
          handleClose={() => setShowModal(false)}
          info={{ type: "agente" }}
        />
      ) : null}
      {/* Modal de asignación de agente */}

      <ModalClients show={show} handleClose={() => setShow(false)} />
    </div>
  );
};

export default ChatHeader;
